import {Component, Input} from "@angular/core";

import {faFloppyDisk} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {FormsModule} from "@angular/forms";

@Component({
    selector: 'save-popup',
    imports: [FontAwesomeModule, FormsModule],
    templateUrl: './save-popup.html',
    styleUrls: ['./save-popup.css']
})
export class SavePopupComponent {
  @Input('show') show: boolean = false
  @Input('message') message: string = "Changes Saved!"
  faFloppyDisk = faFloppyDisk
}
